/**
 * Import Dependency
 */



/**
 * Import API
 */

const CONFIG_DEFAULT = {
  code: null,
  emailAddressSupport: 'support@evtools.nl',
  prognoseModels: [],
};


/**
 * Declare Variable
 */
const state = {
  deployment: process.env.VUE_APP_DEPLOYMENT || 'nl',
  mapbox: process.env.VUE_APP_MAPBOX_ACCOUNT || 'evtools',
  config: {
    nl: {
      code: 'nl',
      country: 'nl',
      // config
      emailAddressSupport: 'support@evtools.nl',
      prognoseModels: ['NAL', 'Sparkcity'],
      // mapbox
      sat: 'https://service.pdok.nl/hwh/luchtfotorgb/wms/v1_0?bbox={bbox-epsg-3857}&styles=&format=image/jpeg&service=WMS&version=2.0&request=GetMap&crs=EPSG:3857&transparent=true&width=256&height=256&layers=2021_quick_orthoHR',
      layers: {
        fastcharge: 'nl_l_elaadnl_prognoses_snelladen',
        gemeentegrenzen: 'nl_l_gemeentegrenzen',
        ls_kabels: 'nl_l_ls_kabels',
        ls_stations: 'nl_l_ls_stations',
        ms_kabels: 'nl_l_ms_kabels',
        ms_stations: 'nl_l_ms_stations',
        ms_ls_stations: 'nl_l_ms_ls_stations',
        fossilfuel_stations: 'nl_l_tankstations',
        park_n_ride: 'nl_l_penr',
        rws_beheergebied: 'nl_l_rws_beheergebied',
        verkeersstromen: 'nl_l_verkeersstromen',
        zh_nieuwbouwlocaties: 'nl_p_zh_nieuwbouwlocaties',
        zh_toplocaties: 'nl_p_zh_toplocaties',
        zh_mrae_plankaart: 'nl_r_mrae_spol',
        hoppin: false,
        carsharing: 'nl_p_zh_deelauto',
        logistics: 'nl_p_zh_stadslogistiek',
        taxis: 'nl_p_zh_taxi',
        gemeenteprognoses: false,
        highway_rest_areas: false,
        car_pool_parking_areas: false,
      },
      // monitoring
      thresholdFastChargerInKw: '23000',
    },
    be: {
      code: 'be',
      country: 'be',
      // config
      emailAddressSupport: 'support@evtools.be',
      prognoseModels: ['VL'],
      // mapbox
      sat: 'https://geoservices.informatievlaanderen.be/raadpleegdiensten/ofw/wms?bbox={bbox-epsg-3857}&styles=&format=image/jpeg&service=WMS&version=2.0&request=GetMap&crs=EPSG:3857&transparent=true&width=256&height=256&layers=OFW',
      layers: {
        fastcharge: false,
        gemeentegrenzen: true,
        ls_kabels: false,
        ls_kasten: false,
        ms_kabels: 'be_l_ms_kabels',
        ms_stations: false,
        ms_ls_stations: false,
        fossilfuel_stations: 'be_l_tankstations', // false, // 
        park_n_ride: 'be_r_vlg_penr',
        rws_beheergebied: false,
        verkeersstromen: false,
        zh_nieuwbouwlocaties: false,
        zh_toplocaties: false,
        zh_mrae_plankaart: false,
        hoppin: 'be_r_vlg_hoppin',
        carsharing: false,
        logistics: false,
        taxis: false,
        gemeenteprognoses: 'be_r_vlg_gemeenteprognoses',
        highway_rest_areas: 'be_l_dienstenzones',
        car_pool_parking_areas: 'be_l_carpoolplaatsen',
      },
      // monitoring
      thresholdFastChargerInKw: '43000',
    }
  }
}

/*
* Layers are deactivated if they are set to false in the config.
*
* If there is only true set for a layer, the name will be auto-generated.
*
* If there is a string set, the string will be used to load the data.
*/
const getters = {
  MapboxAccount: state => state.mapbox,
  DeploymentCode: state => state.config[state.deployment].code,

  DeploymentHasLayer: state => ({layer}) => !!(state.config[state.deployment].layers[layer] || false),
  DeploymentLayerName: (state, getters) => ({layer, scope}) => {
    try {
      let layername = state.config[state.deployment].layers[layer]
      scope = scope || 'l'

      if (layername === true) {
        return `${getters.DeploymentCode}_${scope}_${layer}`
      }
      return layername || false
    } catch (e) {
      return false
    }
  },

  DeploymentConfig: state => {
    return state.config[state.deployment] || CONFIG_DEFAULT
  },

  getEmailAddressSupport: state => {
    return state.config[state.deployment].emailAddressSupport || 'support@evtools.nl'
  },
  getThresholdFastchargerInKw: state => {
    return state.config[state.deployment].thresholdFastChargerInKw || '23000'
  },
  getPrognoseModels: state => {
    return state.config[state.deployment].prognoseModels || []
  }
}
const actions = {}
const mutations = {}

/**
 * Export
 */
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
